import script from "./HelpSidebarDe.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpSidebarDe.vue?vue&type=script&setup=true&lang=js"

import "./HelpSidebarDe.vue?vue&type=style&index=0&id=ec1fc2e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec1fc2e8"]])

export default __exports__